import { render, staticRenderFns } from "./detailsCity.vue?vue&type=template&id=9f47ec68&scoped=true&"
import script from "./detailsCity.vue?vue&type=script&lang=js&"
export * from "./detailsCity.vue?vue&type=script&lang=js&"
import style0 from "./detailsCity.vue?vue&type=style&index=0&id=9f47ec68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f47ec68",
  null
  
)

export default component.exports